import { AreaPriceDetails, PriceDetails, YearlyPriceObject } from './types';

const VillaVSH2026: YearlyPriceObject = {
  1: { fixedFee: 372, consumptionFee: 820, flowFee: undefined },
  2: { fixedFee: 372, consumptionFee: 820, flowFee: undefined },
  3: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  4: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  5: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  6: { fixedFee: 372, consumptionFee: 212, flowFee: undefined },
  7: { fixedFee: 372, consumptionFee: 212, flowFee: undefined },
  8: { fixedFee: 372, consumptionFee: 212, flowFee: undefined },
  9: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  10: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  11: { fixedFee: 372, consumptionFee: 652, flowFee: undefined },
  12: { fixedFee: 372, consumptionFee: 820, flowFee: undefined },
};

const VillaQ2026: YearlyPriceObject = {
  1: { fixedFee: 372, consumptionFee: 788, flowFee: 1.6 },
  2: { fixedFee: 372, consumptionFee: 788, flowFee: 1.6 },
  3: { fixedFee: 372, consumptionFee: 624, flowFee: 1.6 },
  4: { fixedFee: 372, consumptionFee: 624, flowFee: 1.6 },
  5: { fixedFee: 372, consumptionFee: 624, flowFee: 0 },
  6: { fixedFee: 372, consumptionFee: 236, flowFee: 0 },
  7: { fixedFee: 372, consumptionFee: 236, flowFee: 0 },
  8: { fixedFee: 372, consumptionFee: 236, flowFee: 0 },
  9: { fixedFee: 372, consumptionFee: 624, flowFee: 0 },
  10: { fixedFee: 372, consumptionFee: 624, flowFee: 1.6 },
  11: { fixedFee: 372, consumptionFee: 624, flowFee: 1.6 },
  12: { fixedFee: 372, consumptionFee: 788, flowFee: 1.6 },
};

const VillaRW2026: YearlyPriceObject = {
  1: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  2: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  3: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  4: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  5: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  6: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  7: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  8: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  9: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  10: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  11: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
  12: { fixedFee: 452, consumptionFee: 888, flowFee: undefined },
};

const MindreFHQ2026: YearlyPriceObject = {
  1: { fixedFee: 657, consumptionFee: 788, flowFee: 1.6 },
  2: { fixedFee: 657, consumptionFee: 788, flowFee: 1.6 },
  3: { fixedFee: 657, consumptionFee: 624, flowFee: 1.6 },
  4: { fixedFee: 657, consumptionFee: 624, flowFee: 1.6 },
  5: { fixedFee: 657, consumptionFee: 624, flowFee: 0 },
  6: { fixedFee: 657, consumptionFee: 236, flowFee: 0 },
  7: { fixedFee: 657, consumptionFee: 236, flowFee: 0 },
  8: { fixedFee: 657, consumptionFee: 236, flowFee: 0 },
  9: { fixedFee: 657, consumptionFee: 624, flowFee: 0 },
  10: { fixedFee: 657, consumptionFee: 624, flowFee: 1.6 },
  11: { fixedFee: 657, consumptionFee: 624, flowFee: 1.6 },
  12: { fixedFee: 657, consumptionFee: 788, flowFee: 1.6 },
};

const VillaQ2027: YearlyPriceObject = {
  1: { fixedFee: 372, consumptionFee: 804, flowFee: 2.4 },
  2: { fixedFee: 372, consumptionFee: 804, flowFee: 2.4 },
  3: { fixedFee: 372, consumptionFee: 668, flowFee: 2.4 },
  4: { fixedFee: 372, consumptionFee: 668, flowFee: 2.4 },
  5: { fixedFee: 372, consumptionFee: 668, flowFee: 0 },
  6: { fixedFee: 372, consumptionFee: 220, flowFee: 0 },
  7: { fixedFee: 372, consumptionFee: 220, flowFee: 0 },
  8: { fixedFee: 372, consumptionFee: 220, flowFee: 0 },
  9: { fixedFee: 372, consumptionFee: 668, flowFee: 0 },
  10: { fixedFee: 372, consumptionFee: 668, flowFee: 2.4 },
  11: { fixedFee: 372, consumptionFee: 668, flowFee: 2.4 },
  12: { fixedFee: 372, consumptionFee: 804, flowFee: 2.4 },
};

const MindreFHQ2027: YearlyPriceObject = {
  1: { fixedFee: 650, consumptionFee: 804, flowFee: 2.4 },
  2: { fixedFee: 650, consumptionFee: 804, flowFee: 2.4 },
  3: { fixedFee: 650, consumptionFee: 668, flowFee: 2.4 },
  4: { fixedFee: 650, consumptionFee: 668, flowFee: 2.4 },
  5: { fixedFee: 650, consumptionFee: 668, flowFee: 0 },
  6: { fixedFee: 650, consumptionFee: 236, flowFee: 0 },
  7: { fixedFee: 650, consumptionFee: 236, flowFee: 0 },
  8: { fixedFee: 650, consumptionFee: 236, flowFee: 0 },
  9: { fixedFee: 650, consumptionFee: 668, flowFee: 0 },
  10: { fixedFee: 650, consumptionFee: 668, flowFee: 2.4 },
  11: { fixedFee: 650, consumptionFee: 668, flowFee: 2.4 },
  12: { fixedFee: 650, consumptionFee: 804, flowFee: 2.4 },
};

const VillaW2027: YearlyPriceObject = {
  1: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  2: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  3: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  4: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  5: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  6: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  7: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  8: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  9: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  10: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  11: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
  12: { fixedFee: 452, consumptionFee: 964, flowFee: undefined },
};

const VillaR2027: YearlyPriceObject = {
  1: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  2: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  3: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  4: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  5: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  6: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  7: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  8: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  9: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  10: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  11: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
  12: { fixedFee: 452, consumptionFee: 980, flowFee: undefined },
};

const Ovriga2027: YearlyPriceObject = {
  1: { fixedFee: 372, consumptionFee: 876, flowFee: undefined },
  2: { fixedFee: 372, consumptionFee: 876, flowFee: undefined },
  3: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  4: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  5: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  6: { fixedFee: 372, consumptionFee: 216, flowFee: undefined },
  7: { fixedFee: 372, consumptionFee: 216, flowFee: undefined },
  8: { fixedFee: 372, consumptionFee: 216, flowFee: undefined },
  9: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  10: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  11: { fixedFee: 372, consumptionFee: 696, flowFee: undefined },
  12: { fixedFee: 372, consumptionFee: 876, flowFee: undefined },
};

const PricesVillaQ: PriceDetails = {
  2026: VillaQ2026,
  2027: VillaQ2027,
};

const PricesMindreFHVQ: PriceDetails = {
  2026: MindreFHQ2026,
  2027: MindreFHQ2027,
};

const PricesVillaVSH: PriceDetails = {
  2026: VillaVSH2026,
  2027: Ovriga2027,
};

const PricesVillaW: PriceDetails = {
  2026: VillaRW2026,
  2027: VillaW2027,
};

const PricesVillaR: PriceDetails = {
  2026: VillaRW2026,
  2027: VillaR2027,
};

export const PRICE_LIST: AreaPriceDetails = {
  'Villa Q': PricesVillaQ,
  MindreFHVQ: PricesMindreFHVQ,
  'Villa V': PricesVillaVSH,
  'Villa H': PricesVillaVSH,
  'Villa S': PricesVillaVSH,
  'Villa R': PricesVillaR,
  'Villa W': PricesVillaW,
};
